import { Modal } from '@numa-group/ui.modal';

import { RichContent } from '@src/components/common/formatting/rich-content';
import { useCmsContent } from '@src/contexts/cms-content-context';

import styles from './styles.module.css';

export type RequestLinkReservationSuccessModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function RequestLinkReservationSuccessModal({ isOpen, setIsOpen }: RequestLinkReservationSuccessModalProps) {
  const { linkReservationToProfileTwoStepFeature: content } = useCmsContent();

  return (
    <Modal onOpenChange={setIsOpen} open={isOpen} size="large" isFullscreenOnMobile={false}>
      <Modal.Header>
        <Modal.Title>{content.requestSuccessModalTitle}</Modal.Title>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body>
        <div className={styles.modalBody}>
          <RichContent html={content.requestSuccessDescription} />
          <button onClick={() => setIsOpen(false)} className={styles.requestSuccessCta}>
            {content.requestSuccessCtaLabel}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RequestLinkReservationSuccessModal;
